import { useMediaQuery } from "react-responsive";
import { usePreviewViewportWidth } from "@contexts/preview-viewport.context";

const useMinWidth = (minWidth: number) => {
  const previewWidth = usePreviewViewportWidth();
  const matchesViewport = useMediaQuery({ minWidth });
  return previewWidth === undefined ? matchesViewport : previewWidth >= minWidth;
};

export const useIsMinimumMobile = () => useMinWidth(480);

export const useIsMinimumTablet = () => useMinWidth(768);

export const useIsMinimumDesktop = () => useMinWidth(1024);

export const useIsMinimumDesktopLarge = () => useMinWidth(1280);

export const useIsMinimumDesktopXLarge = () => useMinWidth(1440);

/*If the width of the screen >=1441px, it is considered as fullscreen.
Use this hook for fullscreen specific render*/
export const useIsFullScreen = () => useMinWidth(1441);

export const useIsPortrait = () => useMediaQuery({ orientation: "portrait" });
